import { SiteType } from '@app/origami-api/constants';
import { getServerConfig } from '@app/origami-api/server-config';
import { TiFeatures } from '@app/origami-api/constants/features';
import { Action } from '@app/origami-api/constants/actions';
import { SessionService } from '@app/session/session.service';
import { RoomSessionInfo } from '@app/session/session.service';

export class RouteCheckers {
  static isGeneralUserOnRoom(session: SessionService) {
    return !!(session.room.id && session.room.info && session.settings && RouteCheckers.isGeneralUser(session));
  }

  static isGeneralUserOrAuditorOnRoom(session: SessionService) {
    return !!(session.room.id && session.room.info && session.settings && !RouteCheckers.isTemplateSite(session));
  }

  static isGeneralUser(session: SessionService) {
    return !RouteCheckers.isTemplateSite(session) && !RouteCheckers.isUserExternalAuditor(session);
  }

  static isUserAuditor(session: RoomSessionInfo): boolean {
    //return !!user.details.IsUserAuditor;
    return session.info.IsUserAuditor;
  }

  static isUserAuditorsManager(session: RoomSessionInfo): boolean {
    //return !!user.details.IsUserAuditorsManager;
    return session.info.IsUserAuditorsManager;
  }

  static isUserFixer(session: RoomSessionInfo): boolean {
    //return !!user.details.IsUserAuditResponseUser;
    return session.info.IsUserAuditResponseUser;
  }

  static isUserExternalAuditor(session: SessionService): boolean {
    return !!session.user.details.AdditionalInfo.IsUserExternalAuditor && !session.user.adminOrHigher;
  }

  static isSponsor(session: SessionService): boolean {
    return !!session.user.details.AdditionalInfo.IsSponsor && !session.user.adminOrHigher;
  }

  static isQualityRecordsAllowed({ user }: SessionService): boolean {
    return user?.details?.Actions?.some((item) => item.ActionId === Action.QualityRecordsModule);
  }

  static isTemplateSite(session: SessionService): boolean {
    return session.room.info && session.room.info.SiteTypeId === SiteType.Template;
  }

  static isEventManagementEnabled(session: SessionService): boolean {
    return (
      getServerConfig().serverCfg.disabledFeatures.indexOf(TiFeatures.EventManagement) === -1 &&
      (!session.room.id || (session.settings && session.settings.general.module.enableEventManagement.get())) // && (session.user.adminOrHigher || session.user.hasAction(Action.EventManager))
    );
  }

  static isUserEventManager(session: SessionService): boolean {
    return session.user.adminOrHigher || session.user.hasAction(Action.EventManager);
  }

  static isOnRoom(session: SessionService): boolean {
    return !!(session.room.id && session.room.info && session.settings);
  }

  static isOnDomain(session: SessionService): boolean {
    return !session.room.id && !!session.settings;
  }

  static isQualityReviewAvailable(session: SessionService): boolean {
    return (
      session.room.info.IsUserAuditor ||
      session.room.info.IsUserAuditorsManager ||
      session.user.adminOrHigher ||
      this.isUserExternalAuditor(session)
    );
    //(!!session.room.info.IsUserExternalAuditor && !session.user.adminOrHigher) -- isUserExternalAuditorInRoom
  }
}
